<div class="con" [class.astrazeneca]="isAstraZeneca()">
  <div class="progress-info">
    <p class="distance">
      <span class="distance-value">{{ currentDistance() }}</span> km /
      <span class="distance-value">{{ totalDistance() }}</span> km
    </p>
    <div class="progress-value-container">
      <p class="progress-value">{{ progressValue() }}%</p>
    </div>
    <p class="participants">
      <span class="participants-value">{{ nbParticipants() }}</span> participants
    </p>
  </div>
  <div class="progress-bar">
    <div [style.width.%]="progressValue()" [attr.aria-valuenow]="progressValue()" aria-valuemin="0" aria-valuemax="100"
      class="progress-bar-value" role="progressbar"></div>
  </div>
</div>